// extracted by mini-css-extract-plugin
module.exports = {"person":"Person_person__38pb3","avatar":"Person_avatar__2esy_"};